import { Injectable } from '@angular/core';
import { getStore } from './store';

@Injectable()
export class ReduxStoreService {
  getStore() {
      return getStore();
  }
}
